import React from 'react';
import { makeStyles, useTheme } from '@material-ui/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import { Button } from '@material-ui/core';

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },

  title: {
    flexGrow: 1,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    flexShrink: 0,
  },
  drawerPaper: {
    width: '80%',
    [theme.breakpoints.up('md')]: {
      width: '30%',
    },
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },

  drawerTitle: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'center',
  },

  drawerList: {
    padding: theme.spacing(2, 3),
  },

  itemButton: {
      width:"100%",
     // color:theme.palette.text.primary
  },

}));



export default function AppDrawer(props) {
  const classes = useStyles();

  const location = props.location
  //console.log('location: ' ,location)

  const getContainers=(location)=>{
    if(!location|| !location.containers) return []; 
    const listMenus = location.containers.filter(content => !content.hide && content.type == "Menu");
   // console.log('listMenus: ' ,listMenus)
    return listMenus; 
  }
  

  return (
    <div className={classes.root}>
      <Drawer
        className={classes.drawer}
        variant="temporary"
        anchor="right"
        open={props.open}
        classes={{
          paper: classes.drawerPaper,
        }}
        onClose = {props.onClickClose}>
          
        <div className={classes.drawerHeader}>
        <IconButton aria-label="close"  onClick={props.onClickClose}>
        <CancelPresentationIcon fontSize='inherit'/>
        </IconButton>
        
        <div className={classes.drawerTitle}>
            <Typography variant="button">
              {location.name}
            </Typography>
        </div>
        </div>
        <Divider />

        <List className={classes.drawerList}>
         {getContainers(location).map((link)=>(
           <ListItem button key={link.id} onClick = {(id)=>{
             props.onItemClick(link.id)
             props.onClickClose()
             }}> 
                  {/*  <Typography variant="h6">
                      {link.name}
                    </Typography> */}

                    
            <Button
              className={classes.itemButton}        
              variant="text"
              color="text"
            >                 
            {link.name}
            </Button>
            

            </ListItem>
         ))}
        </List>



      </Drawer>
    </div>
  );
}
